import { DragOverlay, useDndContext } from '@dnd-kit/core';
import { Box } from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  page: {
    id: 'autoCuration.pdfSplitEditor.pageNumber',
    defaultMessage: 'Page {num}',
  },
});
/**
 * Renders a copy of a component that is anchored to the mouse when dragging and dropping
 */
export const DragOverlayContent = () => {
  const { active } = useDndContext();
  const { formatMessage } = useIntl();

  return (
    <DragOverlay dropAnimation={null}>
      <Box
        sx={{
          backgroundColor: 'primary.light',
          color: 'primary.contrastText',
          padding: '4px 12px',
          borderRadius: '6px',
          fontSize: '0.85rem',
          fontWeight: 600,
          boxShadow: ({ shadows }) => shadows[10],
        }}
      >
        {formatMessage(messages.page, {
          num: active?.id,
        })}
      </Box>
    </DragOverlay>
  );
};
